module.exports = __webpack_public_path__ + "static/media/g-17.757783a2.jpg";